import React from "react";
import styled from "@emotion/styled"

const ScrollButtonContainer = styled.button`
    opacity: 0.8;
    background-color: #100504;
    color: #faf2f0;
    border-radius: 100%;
    width: 100px;
    height: 100px;
    position: fixed;
    bottom: 10px;
    right: 10px;
    border: none;
    font-family: "Windsor";
    font-size: 1.2rem;
    letter-spacing: 0.1rem;
    z-index: 3;
    cursor: pointer;

    &:hover {
    opacity: 1;
    -webkit-transition: all 0.2s;
    -o-transition: all 0.2s
    transition: all 0.2s;
    }

    @media (max-width: 768px) {
        width: 85px;
        height: 85px;
        font-size: 1rem;
        line-height: 1.2rem;
    }
`

class ScrollButton extends React.Component {
    state = {
         intervalId: 0,
         thePosition: false
     };

    componentDidMount() {
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                this.setState({ thePosition: true })
            } else {
                this.setState({ thePosition: false })
            }
        });
        window.scrollTo(0, 0);
    }
    
    onScrollStep = () => {
        if (window.pageYOffset === 0){
            clearInterval(this.state.intervalId);
        }
        window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    }

    scrollToTop = () => {
        let intervalId = setInterval(this.onScrollStep, this.props.delayInMs);
        this.setState({ intervalId: intervalId });
    }

    renderGoTopIcon = () => {
        if (this.state.thePosition){
            return (
                <ScrollButtonContainer onClick={this.scrollToTop}>
                    Back To Top
                </ScrollButtonContainer>
            )
        }
    }

    render(){
        return (
            <React.Fragment>
                {this.renderGoTopIcon()}
            </React.Fragment>
        )
    }
}

export default ScrollButton